<template>
  <div class="service-upgrading">
    <div class="card">
      <img class="logo" :src="logo" alt="logo" />
      <div class="title">服务正在升级中...</div>
      <div class="desc">我们正在进行系统升级维护，给您带来不便敬请谅解。</div>

    </div>
  </div>
</template>

<script>
import logo from '@/assets/index/logo-seo.png'

export default {
  name: 'ServiceUpgrading',
  data() {
    return {
      logo,
    }
  },
  methods: {
    refresh() {
      window.location.reload()
    },
    goHome() {
      this.$router.push('/')
    },
  },
}
</script>

<style scoped lang="less">
.service-upgrading {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(1200px circle at 20% 20%, #ffffff 0%, #f6f7f9 45%, #eef0f3 100%);
}

.card {
  width: 100%;
  max-width: 520px;
  padding: 36px 28px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 12px 42px rgba(16, 24, 40, 0.12);
  text-align: center;
}

.logo {
  display: block;
  width: 140px;
  margin: 0 auto 18px;
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  letter-spacing: 0.2px;
}

.desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.6;
  color: #6b7280;
}

.actions {
  margin-top: 22px;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  appearance: none;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #111827;
  padding: 10px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  transition: all 0.15s ease;
}

.btn:hover {
  border-color: #9ca3af;
}

.btn.primary {
  border-color: #111827;
  background: #111827;
  color: #ffffff;
}

.btn.primary:hover {
  background: #000000;
  border-color: #000000;
}
</style>
